module.exports = __webpack_public_path__ + "static/img/jp9.edbd385e.png";